export default __webpack_public_path__ + "c26b5899f31cedd82a493e3b3f571c43.png";